import { Navigate } from 'react-router-dom';
import { getPreferredStartRoute } from '../auth/session';

const HomeEntry = () => {
  return <Navigate to={getPreferredStartRoute()} replace />;
};

export default HomeEntry;
